import { useState } from "react";
import { assignColors, groupingKeys } from "ai-management/token-usage/charts";
const NO_COLORS = /* @__PURE__ */ new Map();
const useValueColors = (rows, grouping) => {
  var _a;
  const [colorsByGrouping, setColorsByGrouping] = useState({});
  const assignedColors = (_a = colorsByGrouping[grouping]) != null ? _a : NO_COLORS;
  const colors = assignColors(assignedColors, groupingKeys(rows, grouping));
  if (colors !== assignedColors) {
    setColorsByGrouping({ ...colorsByGrouping, [grouping]: colors });
  }
  return colors;
};
export default useValueColors;
